import React from "react";

export default function TermsPage() {
  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "80px auto 40px", color: "#eee", fontFamily: "Arial, sans-serif", background: "rgba(10, 10, 15, 0.85)", backdropFilter: "blur(10px)", borderRadius: "12px", border: "1px solid #333", boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)" }}>
      <h1 style={{ color: "#0ff", marginBottom: "20px" }}>Conditions Générales d'Utilisation (CGU)</h1>
      <p style={{ color: "#aaa", fontSize: "0.9rem" }}>Dernière mise à jour : {new Date().toLocaleDateString()}</p>

      <section style={{ marginTop: "30px" }}>
        <h2 style={{ color: "#fff" }}>1. Acceptation des conditions</h2>
        <p>
          En accédant à cette application, vous acceptez les présentes CGU sans réserve. Si vous n'êtes pas d'accord, veuillez cesser toute utilisation.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>2. Responsabilité de l'utilisateur (Non-Custodial)</h2>
        <div style={{ border: "1px solid #ffd700", padding: "15px", borderRadius: "8px", background: "rgba(255, 215, 0, 0.1)" }}>
          <p style={{ margin: 0, color: "#ffd700", fontWeight: "bold" }}>
            AVERTISSEMENT DE SÉCURITÉ
          </p>
          <p style={{ marginTop: "10px" }}>
            L'utilisateur reconnaît que l'application ne stocke AUCUNE clé privée ni token généré.
            Il est de la responsabilité exclusive de l'utilisateur de sauvegarder ses informations (clés, tokens, QUID) immédiatement après leur génération.
          </p>
          <p>
            L'éditeur ne pourra être tenu responsable en cas de perte de données, de vol de clés, ou d'oubli de sauvegarde de la part de l'utilisateur.
          </p>
        </div>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>3. Usage autorisé</h2>
        <p>
          L'accès est réservé aux utilisateurs authentifiés. Toute tentative de contournement des sécurités ou d'usage abusif des générateurs d'entropie pourra entraîner la suspension du compte.
        </p>
      </section>

      <section style={{ marginTop: "20px" }}>
        <h2 style={{ color: "#fff" }}>4. Limitation de garantie</h2>
        <p>
          L'application est fournie "en l'état". Bien que nous utilisions des algorithmes cryptographiques avancés (quantiques et pseudo-aléatoires), nous ne garantissons pas l'infaillibilité absolue des systèmes face à des menaces futures (post-quantiques, etc.) au-delà de l'état de l'art actuel.
        </p>
      </section>
    </div>
  );
}
